import React, {useCallback, useMemo, useState} from "react";
import {Button, Center, Field, Input, Stack} from "@chakra-ui/react";
import {userApi} from "../../api/user-api";
import {useToast} from "@chakra-ui/toast";
import {useRecoilState} from "recoil";
import {showTfaCheck} from "../../components/hooks/recoilData";

export interface UserResetParams {
    login: string,
    nickName: string,
    email: string,
    tel: string,
    password: string,
    password2: string,
}

export default function ResetForm(props: {
    pageState: number,
    setPageState: React.Dispatch<React.SetStateAction<number>>
}) {
    const inputDefault: UserResetParams = useMemo(() => {
        return {
            login: "",
            nickName: "",
            email: "",
            tel: "",
            password: "",
            password2: "",
        }
    }, []);
    const [inputParams, setInputParams] = useState<UserResetParams>(inputDefault);
    const toast = useToast();
    const [, setTfa] = useRecoilState(showTfaCheck);
    const [loading, setLoading] = useState(false);

    const reset = useCallback(() => {
        if (inputParams.password !== inputParams.password2) {
            toast({title: "Ошибка регистрации", description: "пароли не совпадают", status: "error"});
            return
        }
        if (!inputParams.email || !inputParams.password || !inputParams.password2) {
            toast({title: "Ошибка формы", description: "поля не заполнены", status: "error"});
            return
        }

        userApi.resetPassword(inputParams.email, inputParams.tel, inputParams.password)
            .then((o) => {
                setTfa(false);
                setLoading(false);
                if (o) {
                    toast({title: "Новый пароль установлен", status: "success"});
                    setInputParams(inputDefault);
                    props.setPageState(0);
                } else {
                    toast({title: "Ошибка сброса", description: "проверьте параметры", status: "error"});
                }
            })
            .catch((err) => {
                setTfa(false);
                setLoading(false);
                console.log("Reset error status code is: " + err);
                toast({title: "Ошибка сброса", description: `code: [${err}]`, status: "error"});
            });
        setTfa(true);
        setLoading(true);
    }, [inputParams, setInputParams, inputDefault, toast, props, setTfa]);

    return (
        <Center>
            <Stack>
                <Center>Укажите Ваши данные для востановления пароля:</Center>
                <Field.Root orientation="horizontal" required>
                    <Field.Label>E-mail <Field.RequiredIndicator/></Field.Label>
                    <Input type="email" placeholder="email"
                           value={inputParams.email}
                           onChange={(it) => setInputParams((prevState) => {
                               return {...prevState, email: it.target.value}
                           })}/>
                </Field.Root>
                <Field.Root orientation="horizontal" required>
                    <Field.Label>Телефон <Field.RequiredIndicator/></Field.Label>
                    <Input type="tel" placeholder="телефон"
                           value={inputParams.tel}
                           onChange={(it) => setInputParams((prevState) => {
                               return {...prevState, tel: it.target.value}
                           })}/>
                </Field.Root>
                <Field.Root orientation="horizontal" required>
                    <Field.Label>Новый пароль <Field.RequiredIndicator/></Field.Label>
                    <Input
                        type="password"
                        placeholder="пароль"
                        value={inputParams.password}
                        onChange={(it) => setInputParams((prevState) => {
                            return {...prevState, password: it.target.value}
                        })}
                    />
                </Field.Root>
                <Field.Root orientation="horizontal" required>
                    <Field.Label>Повторите новый пароль 2 <Field.RequiredIndicator/></Field.Label>
                    <Input
                        type="password"
                        placeholder="пароль"
                        value={inputParams.password2}
                        onChange={(it) => setInputParams((prevState) => {
                            return {...prevState, password2: it.target.value}
                        })}
                    />
                </Field.Root>
                <Button borderRadius={0} variant="solid" colorScheme="teal" width="full" loading={loading} onClick={reset}>
                    Сбросить
                </Button>
                <Button borderRadius={0} variant="outline" width="full" onClick={e => props.setPageState(0)}>
                    К входу
                </Button>
            </Stack>
        </Center>
    );
}